import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 招标采购 - 采购需求
 */
export default {
  path: 'demands',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '采购需求',
    icon: 'icon-side_purchase_demand',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.PURCHASER.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 需求管理
    {
      path: 'manage',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '需求管理'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 需求列表
        {
          path: 'list',
          name: `DemandsList`,
          component: '/procure-views/demands-manage/demands/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '需求列表',
            cache: true,
            hidden: true,
            pageComponentName: 'DemandsList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 新增需求
        {
          path: 'orders/:orderId?/create',
          name: `CreateDemands`,
          component: '/procure-views/demands-manage/demands/process/create',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '新增需求',
            hidden: true,
            needFormKey: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 需求详情
        {
          path: 'orders/:orderId/detail',
          name: `DemandDetail`,
          component: '/procure-views/demands-manage/demands/process/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '需求详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 需求调查
        {
          path: 'orders/:orderId/survey',
          name: `DemandSurvey`,
          component:
            '/procure-views/demands-manage/demands/process/survey/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '需求调查',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 报名审核列表
        {
          path: 'orders/:orderId/sign-up/list',
          name: `DemandSignUpList`,
          component:
            '/procure-views/demands-manage/demands/process/sign-up-list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '报名审核列表',
            cache: true,
            hidden: true,
            pageComponentName: 'DemandSignUpList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 报名审核详情
        {
          path: 'orders/:orderId/sign-up/trade/:tradeId/audit',
          name: `DemandSignUpAudit`,
          component:
            '/procure-views/demands-manage/demands/process/sign-up-audit',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '报名审核详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 报名响应详情
        {
          path: 'orders/:orderId/sign-up/trade/:tradeId/response',
          name: `DemandSignUpResponse`,
          component:
            '/procure-views/demands-manage/demands/process/response-detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '报名响应详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 需求录入
        {
          path: 'orders/:orderId/entry',
          name: `DemandEntry`,
          component: '/procure-views/demands-manage/demands/process/entry',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '需求录入',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 实施计划
    {
      path: 'plan',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '实施计划'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 计划列表
        {
          path: 'list',
          name: `ImplementationPlanList`,
          component: '/procure-views/demands-manage/implementation-plan/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '计划列表',
            cache: true,
            hidden: true,
            pageComponentName: 'ImplementationPlanList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 编制实施计划
        {
          path: ':planId?/edit/:type?',
          name: `ImplementationPlanForm`,
          component: '/procure-views/demands-manage/implementation-plan/form',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '编制实施计划',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 成果文件
    {
      path: 'result',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '成果文件'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.PURCHASER.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 成果列表
        {
          path: 'list',
          name: `ResultPlanList`,
          component: '/procure-views/demands-manage/result/index',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '成果列表',
            cache: true,
            hidden: true,
            pageComponentName: 'ResultPlanList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 需求详情
        {
          path: 'demand-project-detail/order/:orderId?',
          name: `DemandProjectDetail`,
          component: '/procure-views/demands-manage/result/demands-detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '需求详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value },
            { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
          roles: [
            platformFunctionModuleDict.PURCHASER.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
